import React, { useContext } from 'react';

import { IconChevronRightThick, IconChevronUpThick } from '@sololearnorg/sol';
import { AuthService, Container, i18n } from '../../../../symphony';

import { useContainerData } from '../../../../shared/public/SlHooks/useContainerData';
import { SlAISolutionsContext, solutionsData } from '../../global-constants';
import { SlActions } from '../../services/ActionsService/sl-actions';
import {
	ActionType,
	GetSolutionClickSource,
	RequestType,
} from '../../global-interface';
import { SlDataService } from '../../services/sl-data.service';
import { KodieContext } from '../../services/context';
import { CodeAssistantConfigType } from '../../../../api/private/learn-engine-api/learn-engine-api.interface';
import { MaxIcon } from '../../../../_paywalls/private/components/ui/icons';

interface IAISolutionTabProps {
	solutionData: CodeAssistantConfigType['actions'][number];
}

export function AISolutionTab({ solutionData }: IAISolutionTabProps) {
	const { context } = useContext(KodieContext);
	const { actions$ } = Container.take(SlAISolutionsContext, SlActions);
	const {
		aiSolutionsData$: aiSolutionsData,
		aiSolutionsIsOpenedState$: aiSolutionsIsOpenedState,
	} = useContainerData(SlAISolutionsContext, SlDataService, [
		'aiSolutionsData$',
		'aiSolutionsIsOpenedState$',
	]);

	const solutionTabClickHandler = (actionId: number) => {
		actions$.next({
			type: ActionType.OnAISolutionCollapse,
			requestType: RequestType.Parallel,
			data: { actionId, solutionContext: context },
		});
		if (aiSolutionsData[solutionData.action]) return;

		actions$.next({
			type: ActionType.OnAISolutionClick,
			requestType: RequestType.Parallel,
			data: {
				actionId,
				getSolutionClickSource: GetSolutionClickSource.Expand,
				solutionContext: context,
			},
		});
	};

	return (
		<div
			className="ai-solutions__main-section__solution__tab"
			onClick={() => {
				solutionTabClickHandler(solutionData.action);
			}}
		>
			<div className="ai-solutions__main-section__solution__left-part">
				<div className="ai-solutions__main-section__solution__icon">
					{solutionsData[solutionData.action].icon}
				</div>
				<div className="ai-solutions__main-section__solution__name">
					{i18n.t(solutionsData[solutionData.action].title)}
				</div>
				<div className='ai-solutions__main-section__solution__max-icon'>
					<MaxIcon />
				</div>
			</div>
			<div className="ai-solutions__main-section__solution__right-part">
				<div className="ai-solutions__main-section__solution__open-icon">
					{aiSolutionsIsOpenedState[solutionData.action] ? (
						<IconChevronUpThick />
					) : (
						<IconChevronRightThick />
					)}
				</div>
			</div>
		</div>
	);
}
